<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 贈券分析</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2">票券搜尋：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="ticketSearch" placeholder="票券名稱或編號">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">贈送日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2">品牌：</label>
                  <div class="col-md-10">
                    <b-form-checkbox-group v-model="brandSearch" :options="brandOptions"
                      class="mt-2"></b-form-checkbox-group>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2">活動名稱：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="agGroupNameSearch" placeholder="活動名稱">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-warning text-white"
                      @click="getinformationcoupon(1)">查詢</button>
                  </div>
                </div>

                <hr>

                <fieldset>
                  <legend>贈券分析報表匯出</legend>
                  <div class="px-2">
                    <div class="row mt-1" v-if="isInvalidTimeRange">
                      <label class="control-label col-md-2"></label>
                      <label class="control-label col-md-7" style="color: #FF0000;">＊目前無法操作：{{ timeRangeErrorMessage }}</label>
                    </div>
                    <div class="row mt-2">
                      <label class="control-label col-md-2"></label>
                      <label class="control-label col-md-7" style='color:#FF0000;'>＊請勿於10分鐘內重複按[產檔]按紐，以免產檔發生錯誤</label>
                    </div>
                    <div class="row mt-3">
                      <label class="control-label col-md-2">上次產檔時間：</label>
                      <div class="col-md-4">{{ fileTime }}</div>
                      <div class="col-md-3">
                        <button type="button" class="btn btn-publish" @click="showPrompt" :disabled="isInvalidTimeRange || this.FunctionPermission < 2">1.產檔</button>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <label class="control-label col-md-2">產檔狀態：</label>
                      <div class="col-md-4">{{ fileStatus == '0' ? '' : fileStatus == '1' ? '完成' : fileStatus == '2' ?
                        '產檔進行中' : '產檔失敗' }}</div>
                      <div class="col-md-3">
                        <button type="button" class="btn btn-save" @click="exportFileGetResult" :disabled="isInvalidTimeRange">2.更新產檔進度</button>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <label class="control-label col-md-2">產檔人：</label>
                      <div class="col-md-4">{{ fileUserName }}</div>
                      <div class="col-md-3">
                        <button type="button" class="btn btn-save" @click="exportFileDownload"
                          :disabled="fileStatus !== 1 || isInvalidTimeRange || this.FunctionPermission < 2">3.下載csv</button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th>項次</th>
                  <th>活動名稱</th>
                  <th>電子券</th>
                  <th>贈送日期</th>
                  <th>使用期限</th>
                  <th>建立者</th>
                  <th class="col-brand">品牌</th>
                  <th>贈送張數</th>
                  <th>使用張數</th>
                  <th>失效張數</th>
                  <th>使用率</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, index) in coupon" :key="x.id">
                  <td>{{ ((currentPage - 1) * perpage + index + 1) }}</td>
                  <td class="col-active-name">{{ x.ActiveGiveGroupName }}</td>
                  <td class="col-coupon-name">{{ x.CouponName }}</td> <!-- 電子券名稱(長度最長30) -->
                  <td>{{ x.ExpiredStartAt | YYYYMMDD }}</td> <!-- 贈送日期 -->
                  <td>{{ x.ExpiredEndAt | YYYYMMDD }}</td> <!-- 使用期限 -->
                  <td>{{ x.ActiveGiveUserName || x.StoreCode || '門市' }}</td> <!-- 贈券活動的建立者 -->
                  <td class="col-brand">
                    <div class="brand-container">
                      <img v-for="(imgSrc, imgIndex) in getBrandLogos(x.CouponBrandCodes)" :key="imgIndex"
                        class="brand_logo_img" :src="imgSrc" alt="brand-logo" />
                    </div>
                  </td>
                  <td>{{ x.Count }}</td>
                  <td>{{ x.UseCoupon }}</td>
                  <td>{{ x.UnusedCoupon }}</td>
                  <td>{{ x.UseRate }} %</td> <!-- 使用率 -->
                </tr>
              </tbody>
            </table>
            <div class="row" style="padding: 0 1rem">
              <b-pagination size="md" :total-rows="count" v-model="currentPage" :per-page="perpage"
                @change="getinformationcoupon"></b-pagination>
              <label style="margin:8px">{{ startRowNum }}到{{ endRowNum }}，總共 {{ count }}筆</label>
            </div>
          </div>
        </div>
      </b-card>
      <!-- 預覽畫面Modal -->
      <b-modal ref="mdPrompt" hide-footer hide-header>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12" align="center">
              <span>共篩選出 {{ downLoadQty }} 筆資料，請查看產檔進度，<br>於產檔完成後再行下載...</span>
            </div>
          </div>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import IEcharts from 'vue-echarts-v3/src/full.js'
import axios from 'axios'
import { API_URL } from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
export default {
  name: 'echarts',
  components: {
    IEcharts
  },
  data() {
    return {
      sdate: '',
      edate: '',
      ticketSearch: '', // 票券名稱或編號搜尋
      brandSearch: [], // 品牌搜尋
      brandOptions: [
        { text: '麥味登', value: 'MWD' },
        { text: '炸雞大獅', value: 'CM' },
        { text: 'REAL', value: 'REAL' },
        { text: '涮金鍋', value: 'SJ' }
      ],
      agGroupNameSearch: '',  // 贈券活動分組名稱搜尋

      used_coupon: 0,
      invalid_coupon: 0,
      not_used_coupon: 0,
      total_coupon: 0,

      coupon: [],
      currentPage: 1,
      perpage: 20,
      count: 0,
      startRowNum: 0,
      endRowNum: 0,

      // Export stats
      downLoadQty: 0,
      fileTime: '',
      fileName: '',
      fileUserName: '',
      fileStatus: '',
      LoginUserName: '',

      allBrandsImg: require('../../../assets/all_brands.png'),
      brandLogoMap: {
        "MWD": require('../../../assets/mwd.png'),
        "CM": require('../../../assets/cm.png'),
        "REAL": require('../../../assets/real.png'),
        "SJ": require('../../../assets/sj.png')
      }
    }
  },
  created() {
    this.LoginUserName = localStorage.getItem('LoginUserName')
    this.exportFileGetResult()
    this.setdate()
    this.getinformationcoupon(1)
    this.FunctionPermission = getFunctionPermission('F40') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
    }
  },
  methods: {
    onReady(instance) {
      this.instances.push(instance)
    },
    getinformationcoupon(currentPage) {
      var edate = '9999-12-31'
      if (this.edate !== '') {
        edate = this.edate
      }
      if (this.sdate > edate) {
        miniToastr.error('請選擇正確的效期區間')
        return
      }
      var day = parseInt((Date.parse(new Date(edate)) - Date.parse(new Date(this.sdate))) / (1000 * 60 * 60 * 24))
      if (day > 365) {
        miniToastr.success('查詢區間僅限一年')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/gift/certificates-give/v1', {
        sdate: this.sdate,
        edate: this.edate,
        ticketSearch: this.ticketSearch, // 票券搜尋
        brandSearch: this.brandSearch, // 品牌搜尋
        agGroupNameSearch: this.agGroupNameSearch, // 贈券活動分組名稱搜尋
        toPage: currentPage,
        perPage: this.perpage
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.coupon = response.data.data
            this.used_coupon = response.data.usecoupon
            this.currentPage = currentPage
            this.invalid_coupon = response.data.invalidcoupon
            this.not_used_coupon = response.data.unusedcoupon
            this.total_coupon = response.data.totalcoupon
            this.count = (response.data.count === undefined) ? 0 : response.data.count
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.perpage > response.data.count) ? response.data.count : (this.currentPage * this.perpage) >= response.data.count ? response.data.count : this.currentPage * this.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },

    /* ====匯出邏輯==== */
    showPrompt() {
      if (this.sdate === '' || this.edate === '' || this.sdate > this.edate) {
        miniToastr.error('請選擇正確的效期區間')
        return
      }
      this.$parent.Loading = true
      // 1. 先確認下載筆數
      return axios.post(API_URL + '/web/information/exportcoupongivedownloadqty', {
        sdate: this.sdate,
        edate: this.edate,
        ticketSearch: this.ticketSearch,
        brandSearch: this.brandSearch,
        agGroupNameSearch: this.agGroupNameSearch
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.downLoadQty = response.data.downLoadQty
            this.$refs.mdPrompt.show()
            this.exportFile() // 2. 開始產檔
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '查詢下載量失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '系統異常')
          this.$parent.Loading = false
        })
    },
    exportFile() {
      return axios.post(API_URL + '/web/information/exportcoupongive/export', {
        sdate: this.sdate,
        edate: this.edate,
        ticketSearch: this.ticketSearch, // 票券搜尋
        brandSearch: this.brandSearch, // 品牌搜尋
        agGroupNameSearch: this.agGroupNameSearch, // 贈券活動分組名稱搜尋
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.exportFileGetResult()
            setTimeout(() => { this.$refs.mdPrompt.hide() }, 2000)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '產檔失敗')
          }
        })
        .catch((error) => {
          miniToastr.error(error.message, '連線失敗')
        })
    },
    exportFileGetResult() {
      return axios.post(API_URL + '/web/information/exportcoupongive/getResult')
        .then((response) => {
          if (response.data.result === '0000') {
            this.fileTime = response.data.fileTime
            this.fileName = response.data.fileName
            this.fileUserName = response.data.fileUserName
            this.fileStatus = response.data.fileStatus
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          }
        })
        .catch((error) => {
          console.log('無法取得產檔狀態', error)
        })
    },
    exportFileDownload() {
      this.$parent.Loading = true
      return axios({
        method: 'post',
        url: API_URL + '/web/information/exportcoupongive/download',
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.createDownload('贈券分析_' + this.dateFormat_All(new Date()) + '.csv', response.data)
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '下載失敗')
          this.$parent.Loading = false
        })
    },
    createDownload(fileName, content) {
      var blob = new Blob([content])
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 建立下載的連結
      downloadElement.href = href
      downloadElement.download = fileName // 下載後文檔名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 點選下載
      document.body.removeChild(downloadElement) // 下載完成移除元素
      window.URL.revokeObjectURL(href) // 釋放掉blob物件
    },
    dateFormat_All(date) {
      var year = date.getFullYear()
      var mon = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      var day = ('0' + date.getDate()).substr(-2, 2)
      var hour = ('0' + date.getHours()).substr(-2, 2)
      var min = ('0' + date.getMinutes()).substr(-2, 2)
      var sec = ('0' + date.getSeconds()).substr(-2, 2)
      return year + mon + day + hour + min + sec
    },
    setdate() {
      const date = new Date();

      // 建立一個新的日期物件作為起始日
      const firstDay = new Date();
      // 將年份直接減 1，JavaScript 會自動處理如 2月29日 等特殊情況
      firstDay.setFullYear(date.getFullYear() - 1);

      const lastDay = date;

      // 格式化日期並賦值
      this.sdate = this.dateFormat(firstDay);
      this.edate = this.dateFormat(lastDay);
    },
    dateFormat(date) {
      var year = date.getFullYear()
      var mon = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      var day = ('0' + date.getDate()).substr(-2, 2)
      return year + '-' + mon + '-' + day
    },
    // 解析 JSON 字串並對應圖片的函式
    getBrandLogos(brandCodesStr) {
      // 防呆：如果欄位完全是 null 或 undefined，直接回傳全品牌圖
      if (!brandCodesStr) return [this.allBrandsImg];

      try {
        const codes = JSON.parse(brandCodesStr);

        // 如果解析出來是空陣列 []，代表全品牌
        if (Array.isArray(codes) && codes.length === 0) {
          return [this.allBrandsImg]; // 回傳包裝了全品牌圖片路徑的陣列
        }

        // 如果有特定的品牌代號，則照舊對應
        const mappedLogos = codes
          .map(code => this.brandLogoMap[code])
          .filter(url => !!url);

        // 防呆：如果防範未然，萬一有寫代號但對照表找不到，也顯示全品牌圖
        return mappedLogos.length > 0 ? mappedLogos : [this.allBrandsImg];

      } catch (e) {
        console.error("解析品牌欄位失敗:", e);
        // 解析失敗也給予全品牌圖當作預設
        return [this.allBrandsImg];
      }
    }
  },
  computed: {
    isInvalidTimeRange() {
      if (this.sdate === '' || this.edate === '') {
        return true
      }
      if (this.sdate > this.edate) {
        return true
      }
      var day = (Date.parse(new Date(this.edate)) - Date.parse(new Date(this.sdate))) / (1000 * 60 * 60 * 24)
      return day > 365
    },
    timeRangeErrorMessage() {
      if (this.sdate === '' || this.edate === '') {
        return '請先選擇完整的日期區間'
      }
      if (this.sdate > this.edate) {
        return '開始日期不得大於結束日期'
      }
      var day = (Date.parse(new Date(this.edate)) - Date.parse(new Date(this.sdate))) / (1000 * 60 * 60 * 24)
      if (day > 365) {
        return '查詢區間限制為一年內'
      }
      return ''
    }
  },
  filters: {
    YYYYMMDD: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.col-active-name {
  width: 8.5em;
  max-width: 8.5em;
  white-space: normal;
  word-break: break-all;
}
.col-coupon-name {
  width: 12.5em;
  max-width: 12.5em;
  white-space: normal;
  word-break: break-all
}
/* 品牌欄 */
.col-brand {
  text-align: center;
}
/* 裝多個 Logo 的容器 */
.brand-container {
  display: flex;
  align-items: center;
  justify-content: center;
  /* 讓圖片在 td 內置中 */
  gap: 6px;
  /* 每個 Logo 之間的間距 */
  flex-wrap: wrap;
  /* Logo 太多時會自動換行 */
}
/* 單一 Logo 圖片樣式 */
.brand_logo_img {
  width: 35px;
  /* 依據你的畫面調整寬度 */
  height: 35px;
  /* 依據你的畫面調整高度 */
  object-fit: contain;
  /* 保持圖片比例不變形 */
  border-radius: 50%;
  /* 變成圓形 */
  background-color: #fff;
  /* 加上白底，防止部分去背圖片在灰底上看不清楚 */
  border: 1px solid #eee;
  /* 微弱的邊框，讓圓形更明顯 */
}
fieldset {
  padding: 8px 22px 18px;
  margin: 0 0 18px;
  border: 1px solid #519b39;
}
legend {
  padding: 0.2em;
  border: 0;
  width: auto;
  color: #519b39;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/coupongive/List.vue